var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appWhite rounded-lg pa-4"},[_c('app-text',{attrs:{"color":"primary","size":"normal-bold"}},[_vm._v(_vm._s(_vm.cardData.inductionQuestion))]),_c('app-text',{staticClass:"mt-4",attrs:{"color":"grey9","size":"small"}},[_vm._v(_vm._s(_vm.cardData.inductionCorrectAnswer))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }